import { fetchFraudTracking } from '@api';
import { useApplicationStore } from '@data';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useShallow } from 'zustand/shallow';

const SHOW_ATTEMPTS_LESS_THAN = 4;
export function useFraudData() {
  const { fraudData, setFraudData } = useApplicationStore(
    useShallow((state) => ({
      fraudData: state.fraudData,
      setFraudData: state.setFraudData,
    })),
  );
  const [showFraudCounter, setShowFraudCounter] = useState(false);
  const { remainingAttemptCount, toDateTime } = fraudData || {};
  const fraudTimeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    const setFraudTracking = async () => {
      const fraudTracking = await fetchFraudTracking();
      setFraudData(fraudTracking.addCreditCardInvalidAttemptSummary);
    };

    if (
      remainingAttemptCount &&
      remainingAttemptCount < SHOW_ATTEMPTS_LESS_THAN
    ) {
      setShowFraudCounter(true);
      fraudTimeout.current = setTimeout(
        () => {
          setFraudTracking();
        },
        dayjs(toDateTime).diff(dayjs(), 'millisecond'),
      );
    } else {
      setShowFraudCounter(false);
    }
    return () => {
      clearTimeout(fraudTimeout.current!);
      fraudTimeout.current = undefined;
    };
  }, [remainingAttemptCount, setFraudData, toDateTime]);

  return { remainingAttemptCount, showFraudCounter, fraudData };
}
